/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-debugger */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
import React, { useState, useEffect, useReducer, useRef } from "react"; // Added for CHG0073013 
import { connect, useDispatch, useSelector } from "react-redux";
import { 
  Grid, Button
} from "@material-ui/core"; // Added for CHG0073013 
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import XLSX from "sheetjs-style";
import moment from 'moment';
import DownloadIcon from "@mui/icons-material/Download"; // Added for CHG0073013 
import TableSimple from "../../atomicComponents/TableSimple1/TableSimple"; // Added for CHG0073013 
import styles from "./LinkageSearch.module.css";
import {
  CustomFormGroup, ValidatingTextField
} from "../../components/FormComponents"; // Added for CHG0073013 
import BackButton from "../../components/BackButton/BackButton";
import {
  MESSAGE_TYPE,
  RESOURCE_TYPE,  
} from "../../constants";
import { withAllowedOperationsProvider } from "../../hocs";
import { CustomTab } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import Table from "../../components/Table/Table";
import Truckloading from "../../components/CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeCoCodeNumeric, sanitizeNumeric, validateExcelFile, downloadFileFromUrl } from "../../utils/utils"; // Added for CHG0073013 
import apiService from "../../apis/apiService"; // Added for CHG0073013 

const LinkageSearch = () => {
  const history = useHistory();
  const { showPopup } = usePopupManager();
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector
  const [flag, show] = useState(false);
  const [Bc, setBC] = useState(null);
  const [tableArray, setTableArray] = useState([]);
  const [notificationArray, setNotificationArray] = useState([]); // Added for CHG0073013 
  const [loader, setLoader] = useState(true);
  const [asnCount, setAsnCount] = useState(0);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUpload, setIsUpload] = useState(false); // Added for CHG0073013 
  const [selectedFile, setSelectedFile] = useState(null); // Added for CHG0073013 
  const inputRef = useRef(null); // Added for CHG0073013 
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    pers_no: "",
    strworkarea: { label: "All", value: "" },
    BCName: "",
    bcno: { label: "All", value: "" },
    barrel: { label: "", value: "" },
    creation_date: "",
    insrtby: "",
    ProjectDescription: { label: "", value: "" },
    InsertEMP: "",
    action: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
  });
  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    persArea,
  } = auth;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [loading, setLoading] = useState(false); // Added for CHG0073013 
  const [notificationLoading,setNotificationLoading] = useState(false) // Added for CHG0073013 
  const [allTableData, setAllTableData] = useState([]);
  const [isNotification,setIsNotification] = useState(false); // Added for CHG0073013 
  const [allNotificationData, setAllNotificationData] = useState([]); // Added for CHG0073013 
  const dispatch = useDispatch();
  const [selectedRole,setSelectedRole] = useState(''); // Added for CHG0073013
  const [selectedAction, setSelectedAction] = useState(''); // Added for CHG0073013
  const hasOnlyDS = userRole.includes("DS") && !userRole.includes("LI") && !userRole.includes("SA");
  let action
  const handleSearchbtn = async (page, rowsPerPage,actionValue) => { // Added for CHG0073013
    try{  let role = ''
    setLoading(true);
    if (userRole.includes("SA")) {
      role = "SA";
    } else if (userRole.includes("LI")) {
      role = "LI";
    }
      else if (userRole.includes("U")) { // Added for CHG0073013
        role ='U'
      }
      else if (userRole.includes("DS")) { // Added for CHG0073013
        role ='DS'
      }
      // Added for CHG0073013
      const actionMap = {
        View: 'V',
        Delete: 'D',
        Notification: 'N'
      };
    let apiFormatedData = {
      co_code: sanitizeCoCodeNumeric(companyCode),
      pers_no: sanitizeNumeric(personNumber),
      role: selectedRole, // Added for CHG0073013
      action: actionMap[actionValue] || '' // Added for CHG0073013
    };
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/LinkageFilterSearch`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        setIsNotification(false)
        return response.json(setLoading(false)
        );
        })
      .then((responseJson) => {
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          const columnsToRemove = ['creation_dt', 'hours'];
          responseJson.data.map((row, index) => {
            const newRow = { ...row };
            columnsToRemove.forEach(column => delete newRow[column]);
            finalList.push({
              id: index,
              ...newRow
                });
            });
          setAllTableData(finalList)
          setTableArray(finalList);
          setLoading(false);
        } else {
          setTableArray([]);
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Data not Found",   
          });
        }
        setLoading(false);
        setState((prevState) => ({ ...prevState, tableFlag: true }));
        let lowercaseMsg = responseJson.msg.toLowerCase();

        if(lowercaseMsg === "success" ){
          setLoading(false)
        } 
        else if(lowercaseMsg==="fail"){
          setLoading(false)
        }
      })}
      catch(error){
        setLoading(false);
        console.log("error.response: ", error.response);
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later.",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
            }
        }

  };
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      let apiFormatedData = {
        co_code: sanitizeCoCodeNumeric(companyCode),
        pers_no: sanitizeNumeric(personNumber),
        role: 'DS',
        action: '',
      };
      var apiFormatedDataJson = JSON.stringify(apiFormatedData);
      let headerss = new Headers();
      headerss.append("Content-Type", "application/json");
      fetch(`${baseUrl}master/LinkageFilterSearch`, {
        method: "POST",
        headers: headerss,
        body: apiFormatedDataJson,
        credentials:'include'
      })
        .then((response) => {
          dispatch(setLogin({...auth, recentStatus: response.status}))
          return response.json();
          })
        .then((responseJson) => {
          if (responseJson && responseJson.data.length != 0) {
            setState((prevState) => ({ ...prevState, tableFlag: true }));
            const finalList = [];          
            const columnsToRemove = ['creation_dt', 'hours'];
              responseJson.data.map((row, index) => {
              const newRow = { ...row };
              columnsToRemove.forEach(column => delete newRow[column]);
              finalList.push({
                id: index,
                ...newRow
                  });
            });
            setAllTableData(finalList)
            setTableArray(finalList)
            setLoading(false);
          } else {
            setLoading(false);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data not Found",
      
            });
          }
          setState((prevState) => ({ ...prevState, tableFlag: true }));
        })
        .catch((error) => {
          setLoading(false);
                    showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later",
          });
        });
    };

    // Call the API only if hasOnlyDS is true
    if (hasOnlyDS) {
      fetchData();
      setViewDisplay(true);
      setIsDelete(false);
    }
  }, [hasOnlyDS]);
// Start for CHG0073013
  const handleViewbtn = async (actionValue) => {
    setRowsPerPage(10);
    setPage(0);
  
    if (actionValue === "View") {
      setSelectedAction("View");
  
      setViewDisplay(true);
      setIsDelete(false);
      setIsNotification(false);
      setNotificationArray([])
  
      handleSearchbtn(0, 10, "View");
  
    } else if (actionValue === "Delete") {
      setSelectedAction("Delete");
  
      setViewDisplay(false);
      setIsDelete(true);
      setIsNotification(false);
      setNotificationArray([])
  
      handleSearchbtn(0, 10, "Delete");
      renderDeleteReport();
  
    } else if (actionValue === "Notification") {
      setSelectedAction("Notification");
      setViewDisplay(false);
      setIsDelete(false);
      setIsNotification(true);
  
      renderNotification();
    }
  
    setState((prevState) => ({
      ...prevState,
      tableFlag: true
    }));
  }; 
  // END for CHG0073013
  // start
  const [selectedRow, setSelectedRow] = useState([]);
  const handleOpen1 = (selected) => {
    setIsPopupOpen1(true);
    setSelectedRow(selected);
    const apiFormatedData = selected.map((selectedRow) => ({
      mopno: sanitizeNumeric(personNumber),
      personno: sanitizeNumeric(selectedRow.persno),
      projectdef: selectedRow.project_def,
      insrtby: selectedRow.insertedid,
    }));
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/LinkageSearch`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:'include'
    })
      .then((response) =>{
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {

        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: responseJson.status,
          reloads: true, // Set reload to true or false based on your condition
        });
      })
      .catch((error) => { });
  };

  const handleDelete = (selected) => {
    setIsPopupOpen1(true);
    setSelectedRow(selected);
    const apiFormatedData = selected.map((selectedRow) => ({
      mopno: sanitizeNumeric(personNumber),
      personno: sanitizeNumeric(selectedRow.persno),
      projectdef: selectedRow.project_def,
      insrtby: selectedRow.insertedid,
    }));
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}master/LinkageSearchDelete`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
      credentials:"include"
    })
      .then((response) =>{
        dispatch(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg === 'Success') {
          showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: responseJson.data,
            reloads: true, // Set reload to true or false based on your condition
          });
        } else {
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "Oops! Something went wrong. Please try again later",
          });
        }
      })
      .catch((error) => { });
  };

  const [isPopupOpen1, setIsPopupOpen1] = useState(false);

  const baseDefaultColumns = [
    {
      width: 130,
      title: "Person No",
      field: "persno",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: "Person Name",
      field: "persname",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Work Area",
      field: "workarea",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 100,
      title: "BC No",
      field: "bc_number",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 100,
      title: "Barrel",
      field: "barrel",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 130,
      title: "Project Def",
      field: "project_def",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 220,
      title: "Project Description",
      field: "project_desc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 95,
      title: "BU",
      field: "bu",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 110,
      title: "Sub BU",
      field: "sub_bu",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Platform",
      field: "platform",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 110,
      title: "Family",
      field: "family",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Created Date",
      field: "creation_date",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Inserted By",
      field: "insertedid",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Insert Emp Name",
      field: "complete_name",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "From Date",
      field: "effective_date",
      enableSearch: true,
      enableFilter: true,
      render: (row) => (
        moment(row.effective_date).format("DD-MM-YYYY"))
    },
    {
      width: 140,
      title: "To Date",
      field: "end_date",
      enableSearch: true,
      enableFilter: true,
      render: (row) => (
        moment(row.end_date).format("DD-MM-YYYY"))
    },
    // {
    //   width: 140,
    //   title: "Hours",
    //   field: "hours",
    //   enableSearch: true,
    //   enableFilter: true,
    // },
  ];

  const ROW_HEIGHT = 38;
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const setCount = (count) => {
    setAsnCount(count);
  };
  function downloadExcel(data) {
    const columnsKeys = {
      'id': 'Id', 'persno': 'Person No', 'persname': 'Person Name',
      'workarea': 'Work Area', 'bc_number': 'BC No', 'barrel': 'Barrel',
      'project_def': 'Project Def', 'project_desc': 'Project Description',
      'bu': 'BU', 'sub_bu': 'Sub BU', 'family': 'Family', 'creation_date': 'Created Date',
      'platform': 'Platform', 'insertedid': 'Inserted By', 'effective_date': 'From Date',
      'end_date': 'To Date', 'complete_name': 'Insert Emp Name'

    }
    data.forEach((item, index) => { item.id = index + 1; });
    const updateExportData = data.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Linkagedetails.xlsx');
  }

  function handleExport() {
  const filename = "Linkagedetails";
  try {
  if (userRole.includes("SA")) {
  userRole = "SA";
  } else if (userRole.includes("LI")) {
  userRole = "LI";
  }
      let apiFormatedData = {
  co_code: sanitizeCoCodeNumeric(companyCode),
  pers_no: sanitizeNumeric(personNumber),
  role: userRole,
  action: "V" || "D",
  };
  var apiFormatedDataJson = JSON.stringify(apiFormatedData);
  const url = `${baseUrl}master/ExportLinkageFilterSearch`;
  const headerss = new Headers();
  headerss.append("Content-Type", "application/json");
  fetch(url, { method: "POST", headers: headerss, body: apiFormatedDataJson, credentials:'include' })
  .then((response) => {
    dispatch(setLogin({...auth, recentStatus: response.status}));
    return response.blob();
  })
  .then((blob) => URL.createObjectURL(blob))
  .then((uril) => {
  const link = document.createElement("a");
  link.href = uril;
  link.download = `${filename}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  });
  } catch (error) {
  console.log("error", error);
  }
  }
// Changes Start for CHG0073013    

  const handleFileChange = (e) => {
    const file = validateExcelFile(
      e,
      inputRef,
      setSelectedFile,
      showPopup,
    );
    setSelectedFile(file);
  };
  const handleSelectedRole = (e) =>{
    const selectedRole = e
    setSelectedRole(selectedRole);
    setSelectedAction('');
  // Clear other related values here if required
  setViewDisplay(false);
  setIsDelete(false);
  setIsNotification(false)
  }
  const handleDownload = async() => {
   const payload= {
    "path": "LinkageNotificationTemplate.xlsx"
   }
    try {
     const response = await apiService.getDocumentView(payload, dispatch)
      if(response.url){
        downloadFileFromUrl(response.url, "LinkageNotificationTemplate.xlsx");
      }else{      
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Failed to download template",
        });
      }
    } catch (error) {
      console.error("Error downloading template:", error);
      
    }

  }
  
  // Changes Start for CHG0073013  
  const renderHTML = () => (
  
  <>
  {/* ROLE SELECTION */}
  <div className={styles.formGroup}>
    <Grid
      container
      spacing={1}
      style={{ marginTop: "10px" }}
      className={styles.myGrid}
      columns={12}
    >
      <Grid item md={12} lg={12}>
        <div className={styles.rowDiv}>
          <RadioGroup
            row
            aria-labelledby="role-radio-buttons-group"
            name="role-radio-buttons-group"
            className="radio-button-spacing"
            value={selectedRole}
            onChange={(e) => handleSelectedRole(e.target.value)}
          >

            <label
              style={{
                marginTop: "7px",
                marginRight: "10px"
              }}
            >
              Select Role :
            </label>

            {auth?.userRole
              ?.filter(role =>
                ["U", "LI", "DS", "SA"].includes(role)
              )
              .map(role => (
                <FormControlLabel
                  key={role}
                  value={role}
                  className={styles.radiobtn}
                  control={<Radio size="small" />}
                  label={
                    role === "U"
                      ? "User"
                      : role === "LI"
                      ? "Linkage SPOC"
                      : role === "DS"
                      ? "Departmental SPOC"
                      : "Super Admin"
                  }
                />
              ))}

          </RadioGroup>

        </div>
      </Grid>
    </Grid>
  </div>


  {/* ACTION SELECTION */}
  <div className={styles.formGroup}>
    <Grid
      container
      spacing={1}
      style={{ marginTop: "10px" }}
      className={styles.myGrid}
      columns={12}
    >

      {selectedRole && (
        <Grid item md={4} lg={4}>

          <div className={styles.rowDiv}>

            <RadioGroup
              row
              aria-labelledby="action-radio-buttons-group"
              name="action-radio-buttons-group"
              className="radio-button-spacing"
              value={selectedAction}
              onChange={(e) => handleViewbtn(e.target.value)}
            >

              {/* VIEW */}
              {auth?.userRole?.some(role =>
                ["DS", "LI", "SA","U"].includes(role)
              ) && (
                <FormControlLabel
                  value="View"
                  className={styles.radiobtn}
                  control={<Radio size="small" />}
                  label="View"
                  
                />
              )}


              {/* DELETE */}
              {auth?.userRole?.some(role =>
                ["DS", "LI", "SA"].includes(role)
              ) && (
                <FormControlLabel
                  value="Delete"
                  className={styles.radiobtn}
                  control={<Radio size="small" />}
                  label="Delete"
                  disabled={selectedRole === "U"}
                />
              )}


              {/* NOTIFICATION */}
              {auth?.userRole?.includes("SA") && (
                <FormControlLabel
                  value="Notification"
                  className={styles.radiobtn}
                  control={<Radio size="small" />}
                  label="Notification"
                  disabled={
                    selectedRole === "U" ||
                    selectedRole === "DS"
                  }
                />
              )}

            </RadioGroup>

          </div>

        </Grid>
      )}

    </Grid>
  </div>
</>
// Changes END CHG0073013
  );
  const renderReport = () => (
    <>
      <div className={styles.formGroup}>
        <div
          className={styles.col2}
          style={{
            width: "100%",
            height: "65vh",
          }}
        >
          {loading ? (
            <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "40px" }}>
              <Truckloading />
            </div>

          ) : (
            <>
              <Table
                viewDisplay={viewDisplay}
                columns={baseDefaultColumns}
                defaultColumns={baseDefaultColumns}
                rowHeight={ROW_HEIGHT}
                rows={tableArray}
                secondaryActions={[
                  {
                    name: "Export",
                    getFilteredData: true,
                    authOperation: "create-project",
                    shouldEnable: (tableArray) => tableArray,
                    actionFn: filteredData => {

                      downloadExcel(filteredData)
                    },
                  },

                ]}
                setAsnCount={setCount}
                isDataLoading={false}
                actionButtons
                allTableData={allTableData}
                exportAllflag='true'
              />
            </>
          )}
        </div>
      </div>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={6} lg={5} />
      </Grid>
    </>
  );

  const renderDeleteReport = () => (
    <>
      <div className={styles.formGroup}>
        <div
          className={styles.col2}
          style={{
            width: "100%",
            height: "65vh",
          }}
        >
          {loading ? (
            <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "40px" }}>
              <Truckloading />
            </div>) : (
            <>
              <Table
                columns={baseDefaultColumns}
                defaultColumns={baseDefaultColumns}
                rowHeight={ROW_HEIGHT}
                rows={tableArray}
                secondaryActions={[
                  {
                    name: "Delete",
                    authOperation: "create-project",
                    shouldEnable: (selected) => selected.length >= 1,
                    actionFn: (selected) => {
                      handleDelete(selected);
                    },
                  },
                ]}
                setAsnCount={setCount}
                isDataLoading={false}
                actionButtons
              />
            </>

          )}
        </div>
      </div>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{
          marginTop: "10px",
        }}
        columns={12}
      >
        <Grid item md={6} lg={5} />
      </Grid>
    </>
  );
// Changes Start for CHG0073013  
  const [selectedRows, setSelectedRows] = useState([]);
  const handleCheckboxChange = (event, item) => {
    const { checked } = event.target;

    setSelectedRows(prev => {
      if (checked) {
        return [...prev, item];
      }
      return prev.filter(
        row => row.project_code !== item.project_code
      );
    });
  };


  const handleSelectAll = event => {
    const { checked } = event.target;
    if (checked) {
      setSelectedRows([...notificationArray]);
    } else {
      setSelectedRows([]);
    }
  };

  const isAllSelected =
    notificationArray.length > 0 &&
    selectedRows.length === notificationArray.length;

  const isIndeterminate =
    selectedRows.length > 0 &&
    selectedRows.length < notificationArray.length;

    const handleUpload = async() => {
    
      setNotificationLoading(true)
      const formData = new FormData();
      formData.append("file", selectedFile);
      try {
        setNotificationLoading(true)
        const response = await apiService.LinkageNotificationUpload(formData, dispatch);
        if (response.msg === 'Success') {
          setIsUpload(true)
          setNotificationLoading(false)
          setSelectedFile(null)
          setIsNotification(true)
          if(inputRef.current){
            inputRef.current.value = null; // Reset the file input
          }
          setNotificationArray(response?.data);         
          if (response?.close_projects?.length > 0) {
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: `${response?.close_projects.join(', ')} ${response?.close_projects.length === 1 ? 'project is' : 'projects are'} already closed.`
            });                
          }

        } else if(response?.msg === 'Fail'){
          setNotificationLoading(false)
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: `${response?.data}`,
          });
        }
      } catch (error) {
        setNotificationLoading(false)  
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `${error?.response?.data?.data || 'Error uploading file. Please try again.'}`,
        });            
      }
    }
    const handleSendNotification = async() => {
      if (selectedRows.length === 0) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select at least one row to send notification.",
        });
        return;

      }
    
      const payload = {
        projects_data: selectedRows.map(row => ({
          project_code: row.project_def,
          remark: row.remark,
          spoc_details: row.spoc_details
        })),
        created_by: auth?.personNumber,
      };
       try {
          const data = await apiService.LinkageNotificationSend(payload, dispatch)
           showPopup({
            type: MESSAGE_TYPE.SUCCESS,
            contextText: MESSAGE_TYPE.SUCCESS,
            info: "Notification sent successfully!",
          });
       } catch (error) {
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: `${error?.response?.data?.data || 'Error sending notification. Please try again.'}`,
        });     
        
       }

    }


  const renderNotification = () => (
    <div
      className={styles.formGroup}
    // onClick={() => changeBackgroundColor("processInfoBg")}
    >
      {
        isNotification && (
          <Grid
        container
        spacing={2}
        alignItems="center"
        className={styles.myGrid}
      >
        {/* Download Template */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <div className={styles.rowDiv}>
            <div className={styles.lableDiv1}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  cursor: "pointer",
                }}
              >
                <label>Download Template</label>
                <DownloadIcon
                  color="primary"
                  onClick={handleDownload}
                  style={{ marginLeft: 10 }}
                />
              </div>
            </div>
          </div>
        </Grid>

        {/* File Upload */}
        <Grid item xs={12} sm={6} md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <input
                type="file"
                ref={inputRef}
                onChange={handleFileChange}
                id="upload-file"
                data-testid={`upload-file-${document?.id}`}
                className={styles.contentfile}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
          </div>
        </Grid>

        {/* Action Buttons */}
        <Grid item xs={12} sm={12} md={4} lg={5}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <div className={styles.buttonContainer}>
                <Button
                  className={clsx(styles.actionButton, selectedFile
                    ? styles.primaryActionButton
                    : styles.disabledActionButton)}
                  variant="primary"
                  size="small"
                  disabled={!selectedFile}
                  data-testid="confirm-action"
                  onClick={handleUpload}
                >
                  Upload
                </Button>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.resetButton
                  )}
                  variant="tertiary"
                  size="small"
                  onClick={() => {
                    setIsNotification(true)
                    setSelectedFile('')
                    setNotificationArray([])
                    inputRef.current.value = null; // Reset the file input
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
        )
      }
      {
       notificationLoading && (
        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", marginTop: "40px" }}>
          <Truckloading />
        </div>

      ) 
      }
      
     {
      isNotification && notificationArray?.length > 0 &&(
        <Grid
        container
        spacing={2}
        alignItems="center"
        className={styles.myGrid}
      >

        <div
          className={styles.col2}
          style={{
            width: "100%",
            height: "65vh",
          }}
        >           
           {
            isUpload && (
              <>
                 <div style={{ position: 'relative', marginTop: '10px' }}>                 
    
                  <TableSimple
                    tableColumnData={notificationArray?.map((item, index) => ({
                      select: (
                        <input
                          type="checkbox"
                          checked={selectedRows.some(row => row.project_def === item.project_def)}
                          onChange={event => handleCheckboxChange(event, item)}
                          style={{cursor: 'pointer'}}
                        />
                      ),                   
                      ProjectCode: item.project_def || "",                    
                      ProjectCodeDesc:item.project_desc || "",                  
                      BU:item.bu || "",                    
                      Sub_BU:item.sub_bu || "",
                      Family: item.family || "",                   
                      Platform:item.platform || "",                 
                      NoOfDepartments:item.cost_center_count || "",                                     
                      NoOfEmployees: item.person_count || ""                    
                    }))}
                    
                    tableHeaderLabel={[
                      {
                        label: "Select All",
                        width: 80,
                        component: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              flexDirection:"column",
                              whiteSpace: "nowrap",
                            }}
                          >
                             <span>Select All</span>
                            <input
                              type="checkbox"
                              checked={isAllSelected}
                              ref={(checkbox) => {
                                if (checkbox) {
                                  const checkboxRef = checkbox;
                                  checkboxRef.indeterminate = isIndeterminate;
                                }
                              }}
                              onChange={handleSelectAll}
                              style={{
                                width: "15px",
                                height: "15px",
                                cursor: "pointer",
                                margin: 0,
                              }}
                            />                                                   
                          </div>
                        ),
                      },  
                      "Project Code_120",
                      "Project Code Desc_150",
                      "BU_80",
                      "Sub BU_80",
                      "Family_80",
                      "Platform_80",
                      "No of Departments_80",
                      "No of Employees_80",
                    ]}
                    TableRowHederAling="center"
                    size="small"
                    headerColor="#E6F2FF"
                    className="custom-table"
                  />    
                  </div>               
                  <div style={{ margin: "30px", display: "flex",justifyContent:"center", gap:'10px' }}>
                  <Button
                    variant="primary"
                    color="primary"
                    className={clsx(styles.actionButton, selectedRows.length > 0
                      ? styles.primaryActionButton
                      : styles.disabledActionButton)}
                    onClick={handleSendNotification}
                    style={{ marginRight: "0px !important", marginBottom:"20px" }}           
                    disabled={selectedRows?.length ===0 }
                  >
                    Send Notification
                  </Button>
    
                  <Button
                      className={clsx(
                        styles.actionButton,
                        styles.resetButton
                      )}
                      style={{ marginRight: "0px !important" , marginLeft:"0px important" ,marginBottom:"20px"}}
                      variant="tertiary"
                      size="small"
                      onClick={() => setSelectedRows([])}
                    >
                      Cancel
                    </Button>
                  </div>
              </>
             )
            }
        
        </div>
      </Grid>
      )
     }

    </div>
  );
// Changes END for CHG0073013  
  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
        <div
          className={styles.backButtonLastRefreshedDateWrapper}
          style={{ display: "none" }}
        >
          <BackButton
            action="Home"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Project Linkage" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          {!hasOnlyDS && (
            <CustomFormGroup
              header="Linkage Search / Delete"
              body={renderHTML()}
            />
          )}
          {hasOnlyDS && (
            <div>
              {renderReport()}
            </div>
          )}
          {!hasOnlyDS && myState.tableFlag && viewDisplay === true && <>{renderReport()}</>}
          {myState.tableFlag && isDelete === true && (
            <>{renderDeleteReport()}</>
          )}
    {/*  Changes Start for CHG0073013          */}
          {
            myState?.tableFlag  && (
              <>{renderNotification()}</>
            )
          }
    {/* Changes END for CHG0073013         */}
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          ></div>
        )}
      </div>
    </>
  );
};

export default withAllowedOperationsProvider(
  LinkageSearch,
  RESOURCE_TYPE.PROJECT
);